module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [(!_vm.hideHeader) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.label) + " \n        "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.section_id,
      "data-toggle": "collapse",
      "expanded": "true",
      "aria-controls": _vm.section_id
    }
  }, [_c('span', {
    class: _vm.panel_chevron_class
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.panel_collapse_class,
    attrs: {
      "id": _vm.section_id
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a639f48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/section_toggle.vue
// module id = 930
// module chunks = 0